import { CORE } from "./commonRepository";

/**
 * Create conversations
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Create = async (model) =>{
    try{
        const result = await CORE.post('v1/channel/setups', model);
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * Update conversations
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Update = async (model) =>{
    try{
        const result = await CORE.put('v1/channel/setups', model);
        return result;
    }catch(error){
        return error.response;
    }
};


/**
 * List of conversation
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetAll = async (filter) =>{
    try{
        const result = await CORE.get('v1/channel/setups', {
            params: filter
        });
        return result;
    }catch(error){
        return error.response;
    }
};
